import React, { Component } from 'react';
import {Helmet} from "react-helmet";
import { AccountCircle } from '@mui/icons-material';
import BreadCrumbs from '../BreadCrumbs';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container'
import InterpretationsTable from './InterpretationsTable/index.js';
import SessionConstants from '../../config/SessionConstants';
import APIUtils from '../../utils/APIUtils'
import './index.css';
import Loading from '../Loading';

export default class UserDashboard extends Component {

  state = {
    breadCrumbs: [],
    interpretationsData: [],
    administrativeData: [],
    inProgress: 0,
    pending: 0,
    loading:true,
  }

  async componentDidMount() {
    console.log('--UserDashboard.componentDidMount()');
    
    this.setState({
      breadCrumbs: [{
        name: 'UserDashboard',
      }],
    });

    //Load Tasks    
    let response = await APIUtils.getInterpretationsAssignedToUser();
    if (response) { //first check if response at all, else hide loading
        let inProgressInterpretations = response.filter(function(interps) {
          return interps.interpretation.interpretationStatus == 'In Progress';
        });
        let newInterpretations = response.filter(function(interps) {
          return interps.interpretation.interpretationStatus == 'New';
        });
        this.setState({
          interpretationsData: response,
          inProgress: inProgressInterpretations.length,
          newTasks: newInterpretations.length,
          loading: false
        });
    } else {
      this.setState({
        loading: false
      }) 
    }
  }
   
  render() {
    const programId = sessionStorage.getItem(SessionConstants.PROGRAM_ID);
    return (
        <div className="userDashboard pageMinHeight">
          <Loading isLoading={this.state.loading}/>
          <Helmet>
            <title>ED3N - Dashboard</title>
          </Helmet>
          <BreadCrumbs breadCrumbs={this.state.breadCrumbs} />
          <h1 className="pageTitle">Dashboard</h1>
          <Container maxWidth="xl">
            <Grid container spacing={3} className="dashGridContainer">
              <Grid item xs={12} sm= {12} md={6}>
                <Paper className="card userDashCard" elevation={0}>
                  <div className="userDashProfile">
                    <div className="dashProfileIcon">
                      <AccountCircle style={{ fontSize: '6.6rem', transform: 'scale(1.25)' }} />
                    </div>
                    <div className="dashProfileDescription">
                      <div className="dashProfileName">
                        {sessionStorage.getItem(SessionConstants.USER_FIRSTNAME)} {sessionStorage.getItem(SessionConstants.USER_LASTNAME)}</div>
                      <div>{sessionStorage.getItem(SessionConstants.USER_EMAIL)}</div>
                      <div>
                        <ul>
                          <li key={programId}>{programId}</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </Paper>
              </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Paper className="card userDashCard" elevation={0}>
                    <div className="userDashCallout">
                      <div className="dashCalloutNumber">{this.state.newTasks}</div>
                      <div className="dashCalloutDescription">New Assignments</div>
                    </div>
                  </Paper>
                </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Paper className="card userDashCard" elevation={0}>
                  <div className="userDashCallout">
                    <div className="dashCalloutNumber">{this.state.inProgress}</div>
                    <div className="dashCalloutDescription">In-Progress Interpretations</div>
                  </div>
                </Paper>
              </Grid>
              <Grid item xs={12}>
                <Paper className="card userDashTable" elevation={0}>
                  <div className="dashTableDescription">Assigned Interpretations</div>
                  {!this.state.loading ? //prevent showing no data msg before loading completes
                    (this.state.interpretationsData.length ? (
                      <InterpretationsTable
                        data={this.state.interpretationsData}
                      />
                      ) : (
                        <div className="noData">
                          No Assigned Interpretations
                        </div>
                      )
                    )
                  : ''}
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </div>
    );
  }
}
